module.exports = __webpack_public_path__ + "static/media/gif-humblepie-1.08270736.gif";